// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type VacuumTableStatsQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type VacuumTableStatsQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableVacuumInfo: {
    __typename?: "SchemaTableVacuumInfo";
    id: string;
    autovacuumEnabled: boolean;
    autovacuumEnabledDefault: boolean;
    autovacuumVacuumThreshold: number;
    autovacuumVacuumThresholdDefault: number;
    autovacuumVacuumScaleFactor: number;
    autovacuumVacuumScaleFactorDefault: number;
    autovacuumFreezeMaxAge: number;
    autovacuumFreezeMaxAgeDefault: number;
    autovacuumMultixactFreezeMaxAge: number;
    autovacuumMultixactFreezeMaxAgeDefault: number;
    autovacuumVacuumInsertThreshold?: number | null;
    autovacuumVacuumInsertThresholdDefault?: number | null;
    autovacuumVacuumMaxThreshold?: number | null;
    autovacuumVacuumMaxThresholdDefault?: number | null;
    autovacuumVacuumInsertScaleFactor?: number | null;
    autovacuumVacuumInsertScaleFactorDefault?: number | null;
    autovacuumVacuumCostDelay: number;
    autovacuumVacuumCostDelayDefault: number;
    autovacuumVacuumCostLimit: number;
    autovacuumVacuumCostLimitDefault: number;
    autovacuumAnalyzeThreshold: number;
    autovacuumAnalyzeThresholdDefault: number;
    autovacuumAnalyzeScaleFactor: number;
    autovacuumAnalyzeScaleFactorDefault: number;
    vacuumRuns: Array<{
      __typename?: "VacuumRunDetails";
      id: string;
      identity: string;
      autovacuum: boolean;
      toast?: boolean | null;
      expectFreezing?: boolean | null;
      vacuumStart: number;
      vacuumEnd?: number | null;
      relfrozenxidStart?: number | null;
      relfrozenxidEnd?: number | null;
      deadTuplesStart?: number | null;
      deadTuplesEnd?: number | null;
      postgresRole?: {
        __typename?: "PostgresRole";
        id: string;
        name: string;
      } | null;
      phases?: Array<{
        __typename?: "VacuumRunPhase";
        startDate: number;
        endDate: number;
        phase: number;
      }> | null;
    }>;
  };
  getSchemaTableStats?: {
    __typename?: "SchemaTableStatsSeries";
    id: string;
    deadTuples?: Array<Array<number | null> | null> | null;
    liveTuples?: Array<Array<number | null> | null> | null;
    insertsSinceVacuum?: Array<Array<number | null> | null> | null;
    frozenxidAge?: Array<Array<number | null> | null> | null;
    minmxidAge?: Array<Array<number | null> | null> | null;
  } | null;
  getSchemaTableBloatInfo?: {
    __typename?: "SchemaTableBloatInfo";
    id: string;
    estimateAccountsForToast: boolean;
    isPartitionedTable: boolean;
    stats: Array<{
      __typename?: "SchemaTableBloatStats";
      ts: number;
      estimatedBloatBytes?: number | null;
      estimatedDataBytes?: number | null;
      estimatedRows?: number | null;
    }>;
  } | null;
  getSchemaTableEvents: Array<{
    __typename?: "SchemaTableEvent";
    id: string;
    eventType: string;
    occurredAt: number;
  }>;
  getServerDetails: { __typename?: "Server"; id: string; humanId: string };
};

export const VacuumTableStatsDocument = gql`
  query VacuumTableStats(
    $databaseId: ID!
    $tableId: ID!
    $startTs: Int!
    $endTs: Int!
  ) {
    getSchemaTableVacuumInfo(
      databaseId: $databaseId
      schemaTableId: $tableId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      autovacuumEnabled
      autovacuumEnabledDefault
      autovacuumVacuumThreshold
      autovacuumVacuumThresholdDefault
      autovacuumVacuumScaleFactor
      autovacuumVacuumScaleFactorDefault
      autovacuumFreezeMaxAge
      autovacuumFreezeMaxAgeDefault
      autovacuumMultixactFreezeMaxAge
      autovacuumMultixactFreezeMaxAgeDefault
      autovacuumVacuumInsertThreshold
      autovacuumVacuumInsertThresholdDefault
      autovacuumVacuumMaxThreshold
      autovacuumVacuumMaxThresholdDefault
      autovacuumVacuumInsertScaleFactor
      autovacuumVacuumInsertScaleFactorDefault
      autovacuumVacuumCostDelay
      autovacuumVacuumCostDelayDefault
      autovacuumVacuumCostLimit
      autovacuumVacuumCostLimitDefault
      autovacuumAnalyzeThreshold
      autovacuumAnalyzeThresholdDefault
      autovacuumAnalyzeScaleFactor
      autovacuumAnalyzeScaleFactorDefault
      vacuumRuns {
        id
        identity
        autovacuum
        toast
        expectFreezing
        vacuumStart
        vacuumEnd
        relfrozenxidStart
        relfrozenxidEnd
        deadTuplesStart
        deadTuplesEnd
        postgresRole {
          id
          name
        }
        phases {
          startDate
          endDate
          phase
        }
      }
    }
    getSchemaTableStats(
      databaseId: $databaseId
      schemaTableId: $tableId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      deadTuples
      liveTuples
      insertsSinceVacuum
      frozenxidAge
      minmxidAge
    }
    getSchemaTableBloatInfo(
      databaseId: $databaseId
      schemaTableId: $tableId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      estimateAccountsForToast
      isPartitionedTable
      stats {
        ts
        estimatedBloatBytes
        estimatedDataBytes
        estimatedRows
      }
    }
    getSchemaTableEvents(
      databaseId: $databaseId
      schemaTableId: $tableId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      eventType
      occurredAt
    }
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
    }
  }
`;

/**
 * __useVacuumTableStatsQuery__
 *
 * To run a query within a React component, call `useVacuumTableStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacuumTableStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacuumTableStatsQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useVacuumTableStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    VacuumTableStatsQuery,
    VacuumTableStatsQueryVariables
  > &
    (
      | { variables: VacuumTableStatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VacuumTableStatsQuery, VacuumTableStatsQueryVariables>(
    VacuumTableStatsDocument,
    options,
  );
}
export function useVacuumTableStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VacuumTableStatsQuery,
    VacuumTableStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VacuumTableStatsQuery,
    VacuumTableStatsQueryVariables
  >(VacuumTableStatsDocument, options);
}
// @ts-ignore
export function useVacuumTableStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    VacuumTableStatsQuery,
    VacuumTableStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  VacuumTableStatsQuery,
  VacuumTableStatsQueryVariables
>;
export function useVacuumTableStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VacuumTableStatsQuery,
        VacuumTableStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  VacuumTableStatsQuery | undefined,
  VacuumTableStatsQueryVariables
>;
export function useVacuumTableStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VacuumTableStatsQuery,
        VacuumTableStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VacuumTableStatsQuery,
    VacuumTableStatsQueryVariables
  >(VacuumTableStatsDocument, options);
}
export type VacuumTableStatsQueryHookResult = ReturnType<
  typeof useVacuumTableStatsQuery
>;
export type VacuumTableStatsLazyQueryHookResult = ReturnType<
  typeof useVacuumTableStatsLazyQuery
>;
export type VacuumTableStatsSuspenseQueryHookResult = ReturnType<
  typeof useVacuumTableStatsSuspenseQuery
>;
export type VacuumTableStatsQueryResult = Apollo.QueryResult<
  VacuumTableStatsQuery,
  VacuumTableStatsQueryVariables
>;
